<template>
    <div class="common_checkbox_normal_area">
        <input
            :id="id"
            v-model="model"
            type="checkbox"
            class="input"
            :value="inputValue"
            :disabled="disabled"
            :required="required"
        />
        <label :for="id" class="label" :style="labelStyle" :class="className">
            <slot v-if="model" name="check">
                <IconCheckSquare class="on" :color="defaultCheckedColor"/>
            </slot>
            <slot v-else name="uncheck">
                <IconCheckSquareEmpty :color="'#B4B4B4'"/>
            </slot>
            <slot name="labelText"></slot>
        </label>
    </div>
</template>

<script lang="ts">
import IconCheckSquare from '@iamteacherpc/assets/common/icon/IconCheckSquare.vue';
import IconCheckSquareEmpty from '@iamteacherpc/assets/common/icon/IconCheckSquareEmpty.vue';
import {generatekey} from '@/iamteacherpc/utils/key.js';

export default {
    name: 'CommonCheckbox',
    components: {IconCheckSquareEmpty, IconCheckSquare},
    computed: {
        className() {
            return `${this.disabled ? 'disabled' : ''}`;
        },
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        id() {
            return generatekey({category: 'checkbox'});
        },
        defaultCheckedColor() {
            if (this.$isIamschoolStudent) {
                return '#00c1df';
            }
            if (this.$isIamschoolParent) {
                return '#00c6a8';
            }
            if (this.$isIamteacher) {
                return '#3577F8';
            }
            return '#1a1a1a';
        },
    },
    props: {
        value: {
            type: [Boolean, Object, Array],
            required: false,
        },
        inputValue: {
            type: [Boolean, Object, Array],
        },
        labelStyle: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['input'],
};
</script>

<style scoped lang="scss">
.common_checkbox_normal_area::v-deep {
    position: relative;

    .label {
        overflow: hidden;
        position: relative;
        box-sizing: border-box;
        cursor: pointer;
        font-size: 14px;

        &.disabled {
            pointer-events: none;
            cursor: none;
        }
    }

    .input {
        position: absolute;
        top: 0;
        left: 0;
    }
}
</style>
